<app-loader *ngIf="isDisabled"></app-loader>
<form name="ExpenseCategoryForm" (ngSubmit)="Validate(ExpenseCategoryForm)" #ExpenseCategoryForm="ngForm">
    <div class="card">
        <div class="card-header">
            <label>Expense Category</label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <label>Expense Category Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="ExpenseCategoryName"
                        placeholder="Ex. Hotel" [(ngModel)]="ExpenseCategory.ExpenseCategoryName"
                        #ExpenseCategoryName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter expense category name !
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-12">
                    <label>Class Name</label>
                    <input type="text" [maxLength]="100" class="form-control" name="ClassName" placeholder="Ex. 5 Star"
                        [(ngModel)]="ExpenseCategory.ClassName" #ClassName="ngModel">
                    <span class="rightHint">Multiple Class name in comma separated (eg. 4 star,5star)</span>
                    <div class="invalid-feedback">
                        Please enter class name !
                    </div>
                </div>
            </div> -->
            <div class="row">
                <div class="col-md-12">
                    <label>Account GL Code</label>
                    <input type="text" [maxLength]="100" class="form-control" name="AccountGLCode"
                        placeholder="Ex. EX001" [(ngModel)]="ExpenseCategory.AccountGLCode" #AccountGLCode="ngModel">
                    <div class="invalid-feedback">
                        Please enter account gl code !
                    </div>
                </div>
            </div>
            <div class="row py-1">
                <div class="col-md-6">
                    <label class="Label">
                        Local :
                        <input type="checkbox" name="IsLocal" [(ngModel)]="ExpenseCategory.IsLocal" ngbCheckbox />
                    </label>
                </div>
                <div class="col-md-6">
                    <label class="Label">
                        Out Station :
                        <input type="checkbox" name="IsOutStation" [(ngModel)]="ExpenseCategory.IsOutStation" ngbCheckbox />
                    </label>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer m-2">
        <div class="row">
            <div class="col">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="ExpenseCategory.IsActive"
                        [name]="'Active'" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                        Active
                    </label>
                </div>
            </div>
            <div class="col-auto">
                <button type="button" class="btn btn-outline-primary me-1" (click)="close()" [disabled]="isDisabled"
                    ngbTooltip="Cancel" container="body" placement="top">
                    Cancel
                    <span *ngIf="isDisabled" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                </button>

                <button type="submit" class="btn btn-primary" [disabled]="isDisabled"
                    *ngIf="((this.ExpenseCategory.ESS_ExpenseCategoryMasterId == 0 && this.common.PageRight.IsAdd) || (this.ExpenseCategory.ESS_ExpenseCategoryMasterId > 0 && this.common.PageRight.IsEdit))"><i
                        class="bi bi-save2" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save':'Loading...'}}</button>
            </div>
        </div>
    </div>
</form>